/**
 * Returns only the fields from `update` that differ from `original`.
 * Uses JSON serialization for deep comparison.
 */
export function getChangedFields<T extends Record<string, unknown>>(
  original: T,
  update: T,
): Partial<T> {
  const changes: Partial<T> = {};
  for (const key of Object.keys(update) as (keyof T)[]) {
    if (JSON.stringify(original[key]) !== JSON.stringify(update[key])) {
      changes[key] = update[key];
    }
  }
  return changes;
}
